<template>
    <div class="c-author-fans" v-if="list && list.length">
        <div class="u-label">
            <!-- <i class="el-icon-star-off"></i> -->
            <svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M332.664 236.024c-5.068-15.4-19.946-30.468-36.121-30.187-15.639.272-28.631 9.62-35.428 22.357a5.691 5.691 0 01-10.23 0c-6.8-12.737-19.788-22.085-35.428-22.357-16.175-.281-31.052 14.792-36.12 30.187-16.268 49.414 34.306 82.148 69.791 94.671a20.58 20.58 0 0013.744 0c35.476-12.519 86.061-45.243 69.792-94.671z" fill="#f06292"/><g fill="#ffd54f"><path d="M125.852 335.868a11.962 11.962 0 01-17.218-3.684 147.677 147.677 0 013.136-152.857 12.02 12.02 0 0117.458-3.106l12.747 9.787a11.967 11.967 0 012.915 15.792 107.683 107.683 0 00-2.4 109.009 12.059 12.059 0 01-3.49 15.814z"/><path d="M63.179 396.455a11.978 11.978 0 01-17.027-3.243 250.158 250.158 0 013.839-274.588 12.028 12.028 0 0117.2-2.892l19.181 14.483a11.963 11.963 0 012.776 16.2A202.162 202.162 0 0085.9 366.266a12.034 12.034 0 01-3.141 16.255zM386.148 335.868a11.962 11.962 0 0017.218-3.684 147.677 147.677 0 00-3.136-152.857 12.02 12.02 0 00-17.458-3.106l-12.747 9.787a11.967 11.967 0 00-2.915 15.792 107.683 107.683 0 012.4 109.009 12.059 12.059 0 003.49 15.814z"/><path d="M448.821 396.455a11.978 11.978 0 0017.027-3.243 250.158 250.158 0 00-3.839-274.588 12.028 12.028 0 00-17.2-2.892l-19.181 14.483a11.963 11.963 0 00-2.776 16.2 202.162 202.162 0 013.248 219.851 12.034 12.034 0 003.141 16.255z"/></g></svg>
            <span>粉丝榜</span>
        </div>
        <div class="f-avatar">
            <el-tooltip
                class="item"
                effect="dark"
                :content="'累计打赏' + item.money.toString() + '金箔'"
                placement="top"
                v-for="item in list"
                :key="item.pay_user_id"
            >
                <a class="u-fan" :href="authorLink(item.pay_user_id)"
                    ><el-avatar class="u-avatar" shape="circle" :size="20" :src="showAvatar(item.pay_user.avatar)"
                        ><i class="el-icon-s-custom"></i></el-avatar
                ></a>
            </el-tooltip>
            <el-avatar class="u-avatar u-more" shape="circle" :size="20" v-if="total > MAX_LENGTH">
                <span class="f-avatar-num" v-if="total > 99">···</span>
                <span class="f-avatar-num" v-else>+{{ total - MAX_LENGTH }}</span>
            </el-avatar>
        </div>
        <div class="f-bottom">本赛季共 {{ total }} 人为TA赠礼</div>
    </div>
</template>

<script>
import { getFansList } from "../../service/author";
import { showAvatar, authorLink } from "@jx3box/jx3box-common/js/utils";
export default {
    name: "AuthorFans",
    props: {
        uid: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            list: [],
            total: 0,
            MAX_LENGTH : 8,
        };
    },
    methods: {
        getData() {
            getFansList(this.uid).then((res) => {
                this.list = res.data.data.list?.slice(0,this.MAX_LENGTH) || [];
                this.total = res.data.data.totalUser || 0;
            });
        },
        showAvatar,
        authorLink,
    },
    watch: {
        uid: {
            immediate: true,
            handler: function () {
                this.getData();
            },
        },
    },
};
</script>

<style lang="less">
.c-author-fans {
    box-sizing: border-box;
    // padding: 10px;
    // background: #ffffff;
    font-family: "Microsoft YaHei";
    font-style: normal;
    // .h(133px);
    .f-main-box {
        display: flex;
        justify-content: center;
        width: 100%;
        .f-left {
            .w(65.3%);
            .f-l-box {
                .w(100%);
                .h(50px);
                background: #ff7cab;
                border-radius: 5px 0px 0px 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: none;
                .f-l-title {
                    .w(48px);
                    .h(21px);
                    .fz(16px, 21px);
                    font-weight: 700;
                    color: #ffffff;
                }
            }
        }
        .f-right {
            position: relative;
            .w(34.7%);
            .f-r-box {
                display: flex;
                justify-content: center;
                align-items: center;
                flex: none;
                .h(50px);
                .w(100%);
                z-index: 2;
                position: absolute;
                .f-r-num {
                    font-weight: 700;
                    .fz(10px, 13px);
                    .w(100%);
                    color: rgba(0, 0, 0, 0.5);
                    padding-left: 37.5%;
                }
            }
            .f-r-line {
                .h(5px);
                background: #ff7cab;
                border-radius: 0px 5px 5px 0px;
            }
            .f-r-mb {
                .mb(2.5px);
            }
            .f-r-w-80 {
                .w(100%);
            }
            .f-r-w-70 {
                .w(87.5%);
            }
            .f-r-w-30 {
                .w(37.5%);
            }
            .f-r-w-20 {
                .w(25%);
            }
        }
    }
    .f-avatar {
        height: 30px;
        .f-avatar-num {
            .fz(12px);
            color: #888;
            font-weight: 700;
        }
        .u-fan{
            .mr(5px);
        }
    }
    .f-bottom {
        .mt(5px);
        .fz(12px, 14px);
        font-weight: 400;
        color: #888;
        // transform: scale(0.8);
        // transform-origin: 0 0;
    }
}
</style>
